import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
} from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/avatar-1.jpg"
// actions
import { editProfile , resetProfileFlag} from "../../store/actions"
import SweetAlert from "react-bootstrap-sweetalert";

const GooglePayTransfer = props => {
  const [email, setEmail] = useState("")
  const [receiverEmail, setReceiverEmail] = useState("")
  const [amount, setAmount] = useState("")
  const [note, setNode] = useState("")
  const [allbeneficiaries, setAllbeneficiaries] = useState([])
  const [sentSuccessfully, setSentSuccessfully] = useState(false)
  const [sendingFailed, setSendingFailed] = useState(false)
  const [errorMsg, setErrorMsg] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setEmail(obj?.email)
      setTimeout(() => {
        props.resetProfileFlag();
      }, 3000);
    }
  }, [props.success])

  async function handleValidSubmit(event, values) {
    let toPost = {
      email: email,
      type: "Google Pay",
      ...values
    }

    console.log({toPost})

    try {
      // const response = await fetch("https://aang.pinehilltrust.com/api/interbank-transfer/new", {
      const response = await fetch("https://aang.pinehilltrust.com/api/other-transfer/new", {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(toPost),
      });

      const result = await response.json();
      // console.log({result})
      if (!result.msg) {
        setSentSuccessfully(true)
      }
      else{
        setSendingFailed(true)
        setErrorMsg(result?.msg)
      }
      // console.log("Result:", result);
    } catch (error) {
      // console.error("Error:", error);
      setSendingFailed(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">

          {/* Render Breadcrumb */}
          <Breadcrumb title="Pine Hill Trust" breadcrumbItem="Google Pay" />

          {/*<h3 className="card-title mb-4">Paypal</h3>*/}

          <Card>
            <CardBody>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                <h5 className="mb-4">Send to Google Pay Account</h5>
                <Row>
                  <div className="col-md-6 col-sm-12 mb-3">
                    <div className="form-group">
                      <AvField
                          name="receiverEmail"
                          label="Email"
                          value={receiverEmail}
                          className="form-control"
                          placeholder="Enter the google pay email"
                          type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 mb-3">
                    <div className="form-group">
                      <AvField
                          name="amount"
                          label="Amount ($)"
                          value={amount}
                          className="form-control"
                          placeholder="Enter transaction amount"
                          type="text"
                          required
                      />
                    </div>
                  </div>
                </Row>
                <Row>
                  <Col>
                    <div className="form-group">
                      <AvField
                          name="note"
                          label="Note"
                          value={note}
                          className="form-control"
                          placeholder="Enter an optional note"
                          type="textarea"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                    Initiate Transfer
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>

        {sentSuccessfully ? (
            <SweetAlert
                title="Google Pay Transfer Initiated successfully"
                success
                // showCancel
                confirmBtnBsStyle="success"
                // cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setSentSuccessfully(false)
                  window.location.reload();
                }}
                // onCancel={() => {
                //     setSuccessMsg(false)
                // }}
            >
              You will be notified via email of the progress!
            </SweetAlert>
        ) : null}
        {sendingFailed ? (
            <SweetAlert
                title="Error in Initiating Google Pay Transfer"
                warning
                // showCancel
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                // cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setSendingFailed(false)
                  // setsuccess_dlg(true)
                  // setdynamic_title("Deleted")
                  // setdynamic_description("Your file has been deleted.")
                }}
                // onCancel={() => setconfirm_alert(false)}
            >
              {errorMsg}
            </SweetAlert>
        ) : null}
      </div>
    </React.Fragment>
  )
}

GooglePayTransfer.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { editProfile , resetProfileFlag})(GooglePayTransfer)
)
